import { css } from '@emotion/react'
import { CSSProperties, memo } from 'react'
import { format } from 'timeago.js'
import { timestampToDate } from '../../../../utilities/dates'

const sixtyDaysMilliseconds = 5184000000

const rootStyles = css({
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    marginLeft: 2,
    '& > span': {
        color: 'rgb(255, 120, 22)',
        fontWeight: 'bold',
    },
})

interface NewModelBannerProps {
    creation: number
    compact?: boolean
    styleOverrides?: CSSProperties
    timeStyleOverrides?: CSSProperties
}

const NewModelBanner = memo((props: NewModelBannerProps) => {
    const { timeStyleOverrides, styleOverrides, creation, compact } = props
    const creationMilliseconds = creation * 1000
    const sixtyDaysAgo = Date.now() - sixtyDaysMilliseconds
    const isOlderThanSixtyDays = creationMilliseconds < sixtyDaysAgo

    return (
        <div css={rootStyles} style={styleOverrides}>
            Joined
            <span style={timeStyleOverrides}>
                {isOlderThanSixtyDays &&
                    (compact ? '' : ' a few') + ' months ago'}
                {!isOlderThanSixtyDays &&
                    format(timestampToDate(creationMilliseconds))}
            </span>
        </div>
    )
})

export default NewModelBanner
export { NewModelBanner }
